import { app } from '../../../app';
import { Controller } from './header.controller';

app.component('userSharedAccountsHeader', {
    bindings: {account: '<'},
    controller: Controller,
    templateUrl: require('./header.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/header.component.js